"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameOutcomeType = exports.GameAlignmentType = exports.GameDiscussionActionType = void 0;
exports.isGameClosed = isGameClosed;
exports.isGameException = isGameException;
exports.formatSeasonType = formatSeasonType;
var GameDiscussionActionType;
(function (GameDiscussionActionType) {
    GameDiscussionActionType[GameDiscussionActionType["Hide"] = 0] = "Hide";
    GameDiscussionActionType[GameDiscussionActionType["Unhide"] = 1] = "Unhide";
    GameDiscussionActionType[GameDiscussionActionType["HideAll"] = 2] = "HideAll";
    GameDiscussionActionType[GameDiscussionActionType["UnhideAll"] = 3] = "UnhideAll";
    GameDiscussionActionType[GameDiscussionActionType["Like"] = 4] = "Like";
    GameDiscussionActionType[GameDiscussionActionType["Unlike"] = 5] = "Unlike";
    GameDiscussionActionType[GameDiscussionActionType["Report"] = 6] = "Report";
})(GameDiscussionActionType || (exports.GameDiscussionActionType = GameDiscussionActionType = {}));
var GameAlignmentType;
(function (GameAlignmentType) {
    GameAlignmentType[GameAlignmentType["Away"] = 0] = "Away";
    GameAlignmentType[GameAlignmentType["Home"] = 1] = "Home";
})(GameAlignmentType || (exports.GameAlignmentType = GameAlignmentType = {}));
var GameOutcomeType;
(function (GameOutcomeType) {
    GameOutcomeType[GameOutcomeType["Away"] = 0] = "Away";
    GameOutcomeType[GameOutcomeType["Home"] = 1] = "Home";
    GameOutcomeType[GameOutcomeType["Tie"] = 2] = "Tie";
})(GameOutcomeType || (exports.GameOutcomeType = GameOutcomeType = {}));
function isGameClosed(status) {
    switch (status) {
        case "Scheduled":
        case "InProgress":
            return false;
        default:
            return true;
    }
}
function isGameException(status) {
    switch (status) {
        case "Postponed":
        case "Delayed":
        case "Canceled":
            return true;
        default:
            return false;
    }
}
function formatSeasonType(seasonType) {
    switch (seasonType) {
        case 1:
            return "Regular Season";
        case 2:
            return "Preseason";
        case 3:
            return "Postseason";
        case 4:
            return "Offseason";
        case 5:
            return "AllStar";
    }
}
